import {
    AnimationBaseController,
    GameRandom,
} from "../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../modules/@denishussar/html5-game-engine";
import { BgCollisionContainerModel } from "../../Models/BgCollisionContainerModel";
import { GameLogic } from "../../Logic/GameLogic";
import { AnimationContents } from "../AnimationContents";
import { StopperController } from "./BgTiles/StopperController";
import { CollisionSubjectModel } from "../../Models/BgContainerModels/CollisionSubjectModel/CollisionSubjectModel";
import { OutfitController } from "./BgTiles/OutfitController";
import { StopperCollisionModel } from "../../Models/BgContainerModels/CollisionSubjectModel/StopperCollisionModel";
import { ModelEventConstants } from "../../Constants/ModelEventConstants";

export interface IBgCollisionContainerControllerOptions {
}

export class BgCollisionContainerController extends AnimationBaseController {

    $model: BgCollisionContainerModel;

    public constructor(@Inject private _options: IBgCollisionContainerControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("BgCollisionContainerController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: "bg_tile_container",
            modelEvents: {
                [ModelEventConstants.ADD_COLLISION_SUBJECT]: (model: CollisionSubjectModel) => {
                    this._addSubj(model);
                }
            }
        };
    }

    protected onInitialize(): void {
        this.$model.collisionSubject.forEach((subj, i) => {
            this._addSubj(subj);
        });
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
    private _addSubj(model) {
        if (model instanceof StopperCollisionModel) {
            this._addStopperView(model);
        } else {
            this._addOutfitView(model);
        }
    }
    private _addStopperView(model: CollisionSubjectModel) {
        this.addChildController({
            model,
            controller: StopperController
        }, `Stopper-${this._random.createGUID()}`);
    }
    private _addOutfitView(model: CollisionSubjectModel) {
        this.addChildController({
            model,
            controller: OutfitController
        }, `Outfit-${this._random.createGUID()}`);
    }
}

